/**
 * 替代品规则 Service - 业务逻辑层 + Mock 适配
 * 页面组件只调用此 Service 层,不直接调用 API
 */

import { config } from '../../config';
import * as promotionRuleMock from '../../mocks/promotion-rule';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';
import type { ApiResponse, PageData } from '../../types/common';
import type {
  SubstituteRuleDTO,
  SubstituteRuleRawDTO,
  QuerySubstituteRulePageRequest,
  CreateSubstituteRuleRequest,
  UpdateSubstituteRuleRequest,
  EnableSubstituteRuleRequest,
  DisableSubstituteRuleRequest,
  DeleteSubstituteRuleRequest,
  BatchDeleteSubstituteRuleRequest,
} from '../../types/promotion-rule/substituteRule';
import { parseSubstituteRuleDTO } from '../../types/promotion-rule/substituteRule';

// 分页查询替代品规则
export async function pageSubstituteRule(params: QuerySubstituteRulePageRequest): Promise<ApiResponse<PageData<SubstituteRuleDTO>>> {
  if (config.mock) {
    return promotionRuleMock.mockPageSubstituteRule(params);
  }

  return httpClient.post(API_ENDPOINTS.SUBSTITUTE_RULE.PAGE, params);
}

// 查询替代品规则详情（自动 parse 后端返回的 JSON 字符串字段）
export async function getSubstituteRuleDetail(ruleCode: string): Promise<ApiResponse<SubstituteRuleDTO>> {
  if (config.mock) {
    return promotionRuleMock.mockGetSubstituteRuleDetail(ruleCode);
  }

  // httpClient.get 经过 axios 拦截器后实际返回 ApiResponse 结构
  const response: any = await httpClient.get(
    `${API_ENDPOINTS.SUBSTITUTE_RULE.BASE}/${ruleCode}`
  );
  if (response.success && response.data) {
    response.data = parseSubstituteRuleDTO(response.data);
  }
  return response;
}

// 新建替代品规则
export async function createSubstituteRule(data: CreateSubstituteRuleRequest): Promise<ApiResponse<SubstituteRuleDTO>> {
  if (config.mock) {
    return promotionRuleMock.mockCreateSubstituteRule(data);
  }

  return httpClient.post(API_ENDPOINTS.SUBSTITUTE_RULE.CREATE, data);
}

// 编辑替代品规则
export async function updateSubstituteRule(data: UpdateSubstituteRuleRequest): Promise<ApiResponse<SubstituteRuleDTO>> {
  if (config.mock) {
    return promotionRuleMock.mockUpdateSubstituteRule(data);
  }

  return httpClient.post(API_ENDPOINTS.SUBSTITUTE_RULE.UPDATE, data);
}

// 启用替代品规则
export async function enableSubstituteRule(data: EnableSubstituteRuleRequest): Promise<ApiResponse<SubstituteRuleDTO>> {
  if (config.mock) {
    return promotionRuleMock.mockEnableSubstituteRule(data);
  }

  return httpClient.post(API_ENDPOINTS.SUBSTITUTE_RULE.ENABLE, data);
}

// 禁用替代品规则
export async function disableSubstituteRule(data: DisableSubstituteRuleRequest): Promise<ApiResponse<SubstituteRuleDTO>> {
  if (config.mock) {
    return promotionRuleMock.mockDisableSubstituteRule(data);
  }

  return httpClient.post(API_ENDPOINTS.SUBSTITUTE_RULE.DISABLE, data);
}

// 删除替代品规则（单条）
export async function deleteSubstituteRule(data: DeleteSubstituteRuleRequest): Promise<ApiResponse<null>> {
  if (config.mock) {
    return promotionRuleMock.mockDeleteSubstituteRule(data);
  }

  return httpClient.post(API_ENDPOINTS.SUBSTITUTE_RULE.DELETE, data);
}

// 批量删除替代品规则
export async function batchDeleteSubstituteRules(data: BatchDeleteSubstituteRuleRequest): Promise<ApiResponse<null>> {
  if (config.mock) {
    return promotionRuleMock.mockBatchDeleteSubstituteRules(data);
  }

  return httpClient.post(API_ENDPOINTS.SUBSTITUTE_RULE.BATCH_DELETE, data);
}
